export default __webpack_public_path__ + "static/person-video-img-e2c1886408e5c67096c1f717b0500694.jpg";